export default "__VITE_ASSET__LecW4ba8__"